exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/society-user-survey/society-user-survey/society-user-survey.component.css
// module id = ../../../../../src/app/dashboard/society-user-survey/society-user-survey/society-user-survey.component.css
// module chunks = main